// extracted by mini-css-extract-plugin
export default {"grid":"Gallery_grid__x7mRm"};